import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SoftService } from 'src/app/services/data/soft.service';
import { AuthService } from 'src/app/services/auth/auth.service';

@Component({
  selector: 'app-embaded-soft',
  templateUrl: './app-embaded-soft.component.html',
  styleUrls: ['./app-embaded-soft.component.css']
})
export class AppEmbadedSoftComponent implements OnInit {

  loading = true;
  hasList = false;
  hasIdToBeSet = false;
  hasRfToBeSet = false;
  itemSelected = false;
  appLists: any;
  appSubLists: any;
  rfList = [
    {
      name: '868.1',
      value: '868100000'
    },
    {
      name: '868.3',
      value: '868300000'
    },
    {
      name: '868.5',
      value: '868500000'
    },
    {
      name: '867.1',
      value: '867100000'
    },
    {
      name: '867.3',
      value: '867300000'
    },
    {
      name: '867.5',
      value: '867500000'
    },
    {
      name: '867.7',
      value: '867700000'
    },
    {
      name: '867.9',
      value: '867900000'
    }
  ];

  app = '';
  param = '';
  id = '';
  rf = '868100000';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private softService: SoftService,
    private authService: AuthService
  ) { }

  ngOnInit() {
    this.softService.getSoftProductionList().subscribe((res) => {
      this.appLists = res;
      this.loading = false;
    }, err => {
      if (err.status === 403) {
        this.authService.logout();
        this.router.navigate(['login']);
      }
    });
  }


  getSelectedApp(event) {
    const selectedItem = event.itemData;
    this.app = selectedItem.app;
    this.param = '';
    this.id = '';
    this.hasIdToBeSet = selectedItem.hasIdToBeSet;
    this.hasRfToBeSet = selectedItem.hasRfToBeSet;

    if (selectedItem.hasList) {
      this.appSubLists = selectedItem.list;
      this.itemSelected = true;
      this.hasList = true;
    } else {
      this.itemSelected = true;
      this.hasList = false;
    }
  }

  onSubmit(e) {
    e.preventDefault();
    this.softService.getSoftProductionFile(this.app, this.id, this.param, this.rf);
  }

}
